export default "__VITE_ASSET__CUs_$wWj__"